<template>
    <div class="vod-webinars">
        <div class="vod-webinars-title">{{ title }}</div>
        <div class="vod-webinars-content">
            <div
                class="vod-webinar-thumbnail"
                v-for="webinar in webinars"
                :key="webinar.uuid"
                @click="goToWebinar(webinar)"
            >
                <img :src="webinar.thumbnail" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import courses from './Course/courseData'
export default {
    computed: {
        webinars() {
            const type = this.$route.params.type
            return type == 'course'
                ? courses
                : this.$store.getters['content/webinarsByType'](type)
        },
        title() {
            const type = this.$route.params.type
            switch (type) {
                case 'teacher':
                    return this.$t('FOR_TEACHER')
                case 'parent':
                    return this.$t('FOR_PARENT')
                case 'principal':
                    return this.$t('FOR_PRINCIPAL')
                case 'course':
                    return 'Kursy'
                default:
                    return 'Wszystkie'
            }
        }
    },
    methods: {
        goToWebinar(webinar) {
            if (!webinar.uuid) {
                return
            }
            const base = webinar.type == 'course' ? '/course' : '/webinar'
            this.$router.push(`${base}/${webinar.uuid}`)
        }
    }
}
</script>
<style lang="scss" scoped>
.vod-webinars {
    padding: 5rem;
}
.vod-webinars-title {
    font-size: 2rem;
}
.vod-webinars-content {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
}
.vod-webinar-thumbnail {
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: $ease;

    &:hover {
        transform: scale(1.01);
    }

    img {
        width: 100%;
    }
}
@media (max-width: 1000px) {
    .vod-webinars {
        padding: 2rem;
        padding-top: 4rem;
    }
}
</style>
